import React from "react";
import { fmt } from "./ui";

const SERIES = [
  ["traffic", "Traffic", "var(--ams-blue)"],
  ["conversion", "Conversion", "var(--ams-lime)"],
  ["other", "Other", "var(--ams-muted)"],
];
const W = 720, H = 270, PAD = { l: 46, r: 8, t: 10, b: 26 };

function niceMax(v) {
  if (v <= 0) return 10;
  const p = 10 ** Math.floor(Math.log10(v));
  const n = v / p;
  return (n <= 1 ? 1 : n <= 2 ? 2 : n <= 5 ? 5 : 10) * p;
}

/** Raw records received per UTC hour, stacked by dataset. */
export default function HourlyChart({ data }) {
  if (!data) return null;
  const totals = data.hours.map((_, i) => SERIES.reduce((s, [k]) => s + (data[k][i] || 0), 0));
  const max = niceMax(Math.max(...totals));
  const plotW = W - PAD.l - PAD.r, plotH = H - PAD.t - PAD.b;
  const bw = plotW / 24;
  const y = (v) => PAD.t + plotH - (v / max) * plotH;
  const ticks = [0, max / 2, max];

  return (
    <div className="ams-chart">
      <svg viewBox={`0 0 ${W} ${H}`} role="img" aria-label="Raw records received per UTC hour">
        {ticks.map((t) => (
          <g key={t}>
            <line x1={PAD.l} x2={W - PAD.r} y1={y(t)} y2={y(t)} className="ams-chart-grid" />
            <text x={PAD.l - 8} y={y(t) + 4} textAnchor="end" className="ams-chart-label">{fmt(t)}</text>
          </g>
        ))}
        {data.hours.map((h, i) => {
          let base = 0;
          return (
            <g key={h}>
              {SERIES.map(([k, label, color]) => {
                const v = data[k][i] || 0;
                if (!v) return null;
                const top = y(base + v), bottom = y(base);
                base += v;
                return (
                  <rect key={k} x={PAD.l + i * bw + 2} width={bw - 4} y={top} height={Math.max(0, bottom - top)} fill={color}>
                    <title>{`${String(h).padStart(2, "0")}:00 UTC, ${label}: ${fmt(v)}`}</title>
                  </rect>
                );
              })}
              {i % 3 === 0 && (
                <text x={PAD.l + i * bw + bw / 2} y={H - 8} textAnchor="middle" className="ams-chart-label">
                  {`${String(h).padStart(2, "0")}:00`}
                </text>
              )}
            </g>
          );
        })}
      </svg>
      <div className="ams-legend">
        {SERIES.map(([k, label, color]) => (
          <span key={k}><i style={{ background: color }} />{label}</span>
        ))}
      </div>
    </div>
  );
}
